import {
   GET_SETTINGS,
   // SAVE_BANNERTYPE_URL,
   // STATUS_BANNERTYPE_URL,
   // GET_BANNER_URL,
   // SAVE_BANNER_URL,
   // STATUS_BANNER_URL,
} from '../../Resources/Api';
import axios from "axios";

// const authToken = localStorage.getItem('accessToken');

// Get User List
export function getSettings(authToken, toast) {
   return async function (dispatch) {
      dispatch({
         type: 'LOADING_STATUS',
         payload: {
            status: true,
            string: 'settings'
         }
      })

      axios({
         method: 'GET',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: GET_SETTINGS,
      })
         .then(function (response) {
            // console.log('GET_SETTINGS=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  dispatch({
                     type: 'GET_SETTINGS',
                     payload: response.data.data
                  })
                  dispatch({
                     type: 'LOADING_STATUS',
                     payload: {
                        status: false,
                        string: 'settings'
                     }
                  })
                  
               } else {
                  dispatch({
                     type: 'LOADING_STATUS',
                     payload: {
                        status: false,
                        string: 'settings'
                     }
                  })
                  toast.warn("No reord found");
               }
            } else {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: {
                     status: false,
                     string: 'settings'
                  }
               })
               toast.warn(response.data.message);
            }
         })
         .catch(function (error) {
            dispatch({
               type: 'LOADING_STATUS',
               payload: false
            })
            toast.warn("Something went wrong, Please try again");
            console.log(error);
         });
   }
}